import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

const COLS = [
  { title: "Shop", links: [["All garments", "/shop"], ["T-shirts", "/shop?category=tshirts"], ["Hoodies", "/shop?category=hoodies"], ["Accessories", "/shop?category=accessories"]] },
  { title: "Help", links: [["Track an order", "/track"], ["Sign in", "/login"], ["Orders", "/account"]] },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="overflow-hidden bg-ink text-bone">
    <div className="mx-auto grid max-w-[1600px] gap-12 px-5 pt-20 md:grid-cols-12 md:px-10">
      <div className="md:col-span-6">
        <LogoMark invert className="h-20" />
        <p className="mt-6 max-w-md font-display text-3xl font-light leading-snug md:text-4xl">
          Quiet garments for loud minds. <em className="text-zinc-400">Designed to be worn for years, not seasons.</em>
        </p>
      </div>
      {COLS.map((c) => (
        <div key={c.title} className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">{c.title}</p>
          <ul className="mt-5 space-y-3">
            {c.links.map(([label, to]) => (
              <li key={label}><Link to={to} className="link-underline text-sm" data-testid={`footer-link-${label.toLowerCase().replace(" ", "-")}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div aria-hidden="true" className="mt-16 select-none px-3 font-display text-[27vw] italic leading-[0.75] tracking-tighter text-bone/95 md:text-[24vw]">
      goencho
    </div>
    <div className="mx-auto flex max-w-[1600px] justify-between border-t border-white/10 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 md:px-10">
      <span>© 2026 goencho</span>
      <span>Essentials</span>
    </div>
  </footer>
);
